import React from "react";

export default function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.023"
      height="17.023"
      viewBox="0 0 17.023 17.023"
    >
      <path
        id="Path_18515"
        data-name="Path 18515"
        d="M15.057,9.225l-1.34-1.34L4.895,16.709v1.34h1.34Zm1.34-1.34,1.34-1.34L16.4,5.206l-1.34,1.34ZM7.019,19.943H3V15.924L15.727,3.2a.947.947,0,0,1,1.34,0l2.679,2.679a.947.947,0,0,1,0,1.34Z"
        transform="translate(-3 -2.919)"
        fill="#03f"
      />
    </svg>
  );
}
